import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import HttpService from 'service/HttpService';
import OrderStore from 'stores/OrderStore';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';

import {A} from 'views/AppElements';
import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, RadioButton, ComboBox} from 'views/FormElements';

const DELIVERY_TYPE = AppConstants.DELIVERY_TYPE;
const DELIVERY_LOCATION_TYPE = AppConstants.DELIVERY_LOCATION_TYPE;

const OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
const INSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.INSIDE_KTM_VALLEY;

const INSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.INSIDE_RING_ROAD;
const OUTSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD;

class OrderSettingsForm extends React.Component {

	constructor(props) {
		super(props);
		
		const order = props.order;
		this.INIT_VALUES = {productPrice: order.productPrice,
							productMargin: order.productMargin,
							quantity: order.quantity,
							productSizes: order.productSizes,
							locationType: order.locationType,
							deliveryType: order.deliveryType,
							phone: order.phone,
							orderedProductImage: order.orderedProductImage,
							streetAddress: order.streetAddress,
							additionalNote: order.additionalNote,
							paid: order.paid === true? "true": "false",
							orderMetaData: order.orderMetaData? JSON.stringify(order.orderMetaData): '',
							sizeMetaData: order.sizeMetaData? JSON.stringify(order.sizeMetaData): ''
						};

		this.handleSubmission = this.handleSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
		    productPrice: Yup.string().required('Please enter a price.'),
		    productMargin: Yup.string().required('Please enter a margin.'),
		    quantity: Yup.number().required('Enter a quantity').min(1, "Enter a positive quantity"),
		    productSizes: Yup.array().min(1, "Select a preferrable size"),
			locationType: Yup.string().required("Where is customer located?"),
			deliveryType: Yup.string().when('locationType', (locationType, schema) => {
				return locationType === INSIDE_KTM_VALLEY.val? Yup.string().required("Specify how customer would like to get it delivered."): Yup.string();
			}),
			phone: AppUtil.phoneNumberValidation(),
			orderedProductImage: Yup.string().required('Please select an image'),
		    streetAddress: Yup.string().required('Please enter a street address.'),
		});
	}

	handleSubmission(values, {setSubmitting}) {
		const order = this.props.order;
		
		const updateReq = Object.assign({}, values);
		updateReq.paid = values.paid === "true";
		updateReq.orderMetaData = values.orderMetaData? JSON.parse(values.orderMetaData): null;
		updateReq.sizeMetaData = values.sizeMetaData? JSON.parse(values.sizeMetaData): null;

		HttpService.updateOrder(order.orderId, updateReq, function(success) {
			setSubmitting(false);
		});
	}

	render() {
		const order = this.props.order;
		const productSizes = AppUtil.getProductSizeOptions(order.product);
		const hasOutsideRingroadCharge = order.product.outsideRingRoadCharge || false;

		return <div>
					<h3><A href="/order/dashboard">Go Back to Orders</A></h3>
					<h1>Order Id: {order.orderId}</h1>
					<Formik enableReinitialize initialValues={this.INIT_VALUES} onSubmit={this.handleSubmission}
						validationSchema={this.validationScheme} render={({values, setFieldValue, isSubmitting}) => {
							let submitBtn = "Update";
		
							if(isSubmitting === true)
								submitBtn = <span>Updating <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;
							
							
							const productImages = order.product.productImages.map(i => {
													const style = {marginRight: '10px', cursor: 'pointer'};

													if(i === values.orderedProductImage) {
														style.opacity = "1.0";
														style.border = "1px solid black";
													} else {
														style.opacity = "0.3";
													}

													return <img key={"order_"+order.orderId+"_image_"+i} src={i} 
															className="miniImg" style={style} 
															alt={"Ordered Product"}
															onClick={() => {
																setFieldValue('orderedProductImage', i);
															}}/>
												});

							return <RGForm>
								<Input name="productPrice" type="text" label="Product Price: " />
								<Input name="productMargin" type="text" label="Product Margin: " />
								<Input label="Quantity: " name="quantity" type="text" />
								<div className='flexRow'>
									<RadioButton style={{flexGrow: '1'}} name="paid" value={"true"} 
													label={<span style={{color: '#596161'}}>Paid</span>} 
													checked={values.paid === "true"} />
															

									<RadioButton style={{flexGrow: '1'}} name="paid" value={"false"} 
													label={<span style={{color: '#596161'}}>UnPaid</span>} 
													checked={values.paid === "false"} />
								</div>
								<ComboBox name="productSizes" value={values.productSizes} 
													options={productSizes} placeholder="Select Size" multi={true} />

								<h2 style={{color: 'gray'}}>Delivery Detail</h2>
								<label style={{fontSize: '12px', color: 'rgba(0,0,0,.54)', marginBottom: '10px'}}>Where are you located?</label>
								<div className='flexColumn'>
									{
										!hasOutsideRingroadCharge &&
										<RadioButton style={{flexGrow: '1'}} name="locationType" value={INSIDE_KTM_VALLEY.val} 
													label={<span style={{color: '#596161'}}>{INSIDE_KTM_VALLEY.label}</span>} 
													checked={values.locationType === INSIDE_KTM_VALLEY.val} 
													/>
									}
									
									{
										hasOutsideRingroadCharge &&
										<RadioButton style={{flexGrow: '1'}} name="locationType" value={INSIDE_RING_ROAD.val} 
													label={<span style={{color: '#596161'}}>{INSIDE_RING_ROAD.label}</span>} 
													checked={values.locationType === INSIDE_RING_ROAD.val} 
													/>
									}


									{
										hasOutsideRingroadCharge &&
										<RadioButton style={{flexGrow: '1'}} name="locationType" value={OUTSIDE_RING_ROAD.val} 
													label={<span style={{color: '#596161'}}>{OUTSIDE_RING_ROAD.label}</span>} 
													checked={values.locationType === OUTSIDE_RING_ROAD.val} 
													/>
									}
									
									<RadioButton style={{flexGrow: '1'}} name="locationType" value={OUTSIDE_KTM_VALLEY.val} 
													label={<span style={{color: '#596161'}}>{OUTSIDE_KTM_VALLEY.label}</span>} 
													checked={values.locationType === OUTSIDE_KTM_VALLEY.val} 
													/>

									

								</div>

								<Input label="Phone: " name="phone" type="text" placeholder="E.g. 9862441133"/>
								<Input label="Street Address: " name="streetAddress" type="text" placeholder="E.g. GopiKrishna Nagar, Chabahil, KTM"/>
								<TextArea placeholder={"Extra note for your delivery or any landmark detail (Optional)"}  name="additionalNote" rows="3" />



								{
									(values.locationType === INSIDE_KTM_VALLEY.val 
									|| values.locationType === OUTSIDE_RING_ROAD.val 
									|| values.locationType === INSIDE_RING_ROAD.val) &&

									<div>
										<h2 style={{color: 'gray'}}>Delivery Option</h2>
										<div className='flexRow'>
											<RadioButton style={{flexGrow: '1'}} name="deliveryType" value={DELIVERY_TYPE.REGULAR.val} 
														label={DELIVERY_TYPE.REGULAR.label} 
														checked={values.deliveryType === DELIVERY_TYPE.REGULAR.val} />
											
											<RadioButton style={{flexGrow: '1'}} name="deliveryType" value={DELIVERY_TYPE.IMMEDIATE.val} 
														label={DELIVERY_TYPE.IMMEDIATE.label} 
														checked={values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val} />
										</div>
									</div>
								}

								<div>
									<h2 style={{color: 'gray'}}>Order MetaData</h2>
									<TextArea placeholder={"Order MetaData json string"}  name="orderMetaData" rows="3" />
								</div>

								<div>
									<h2 style={{color: 'gray'}}>Size MetaData</h2>
									<TextArea placeholder={"Size meta data json string"}  name="sizeMetaData" rows="3" />
								</div>
								<Input name="orderedProductImage" type="hidden" disabled={true} />

								<div className="flexRow">
									{productImages}
								</div>
								
								<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
									{submitBtn}
								</SubmitButton>
							</RGForm>
						}} />
			</div>
	}
}




class OrderSettingsContainer extends React.Component {
	static getStores() {
		return [OrderStore];
	}

	static calculateState(prevState, props) {
		const orderId = props.orderId;
		const newState = {
				order: OrderStore.getOrder(orderId)
			};
		return newState;
	}

	componentDidMount() {
		if(this.state.order === null || !this.state.order.product) {
			HttpService.getOrder(this.props.orderId);
		}
	}

	render() {
		const order = this.state.order;

		if(order === null)
			return null;

		
		return <div className="mainContainer" style={{width: '50%', margin: '20px auto', 
										'@media (max-width: 500px)': {width: 'auto', padding: '20px', margin: '0'}}}>
				<OrderSettingsForm order={order} />
			</div>;
	}
}


export default Container.create(Radium(OrderSettingsContainer), {withProps: true});



// WEBPACK FOOTER //
// ./src/containers/OrderSettingsContainer.js